(ns manage.adset-template-page.view.add-modal
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            [cljs-bean.core :refer [->clj]]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.adset :as adset-queries]
            [common.resource.query.advertiser :refer [copy-pre-made-template-mutation]]
            [common.resource.query.template :as template.q]
            [manage.adset-template-page.view.templates-selection :as ts]
            [manage.template-table.db :refer [template-table-ns]]
            [mate.core :as mc]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui] :as uix]
            [uix.re-frame :refer [use-subscribe]]))

(defn- get-row-id [row]
  (:id row))

(defui footer
  [{:keys [qualify on-ok-action multiselect-enabled? channel]}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {rows :value} (use-subscribe [(qualify :unpaginated-value)])
        {pre-made-templates :data} (use-query (template.q/pre-made-templates-query {:channel channel}))
        selected-row-ids (use-subscribe [(qualify :selected-rows)])
        selected-state (use-subscribe [(qualify :selected-state)])

        {copy-pre-made-template :mutateAsync} (use-mutation (copy-pre-made-template-mutation {:advertiser-id advertiser-id}))
        assign-with-pre-made-templates (uix/use-callback (fn [pre-made-templates assign-callback]
                                                           (-> (js/Promise.all
                                                                (map (fn [item]
                                                                       ;; Copy each pre-made to advertiser
                                                                       (.then (copy-pre-made-template {:id (:id item)})
                                                                              (fn [^js result]
                                                                                {:latestRevision (->clj result)})))
                                                                     pre-made-templates))
                                                               (.then (fn [^js resolved]
                                                                        ;; Assign copied pre-mades with callback
                                                                        (assign-callback resolved)))))
                                                         [copy-pre-made-template])]
    ($ Stack
       {:direction "row"
        :spacing 1
        :sx #js {:alignSelf "end"
                 :px 2}}
       ($ Button
          {:onClick #(rf/dispatch [:modal/close])
           :variant "link"}
          "Cancel")
       ($ Button
          {:onClick (fn [^js _event]
                      (rf/dispatch [:modal/close])
                      (let [id->row (mc/index-by get-row-id rows)
                            id->pre-made-template (mc/index-by get-row-id pre-made-templates)
                            selected-templates (keep id->row selected-row-ids)
                            selected-pre-made-templates (keep id->pre-made-template selected-row-ids)]

                        (if (seq selected-pre-made-templates)
                          (assign-with-pre-made-templates selected-pre-made-templates
                                                          (fn assign-callback [pre-made-templates]
                                                            (on-ok-action (concat selected-templates
                                                                                  pre-made-templates))))
                          (on-ok-action selected-templates))))
           :data-testid :add-templates-button
           :variant "contained"
           :disabled (= selected-state :none)}
          (if multiselect-enabled?
            "Add Templates"
            "Select Template")))))

(defui add-template-modal [{:keys [qualify multiselect-enabled? channel]}]
  (uix/use-effect (fn []
                    (rf/dispatch [(qualify :init)]))
                  [qualify])
  ($ Stack
     {:sx #js {:gap 2
               :minWidth 720
               :minHeight 300
               :overflow "hidden"}}
     ($ ts/audit-alert
        {:channel channel})
     ($ ts/filter-input
        {:qualify qualify})
     ($ ts/templates-selection-table
        {:qualify qualify
         :multiselect-enabled? multiselect-enabled?
         :channel channel
         :select-fn nil})))

(defmodal legacy-add-template :legacy/add-template-modal
  []
  (let [{:keys [campaign-id adset-id]} (use-subscribe [:url-context])
        {{:keys [channel]} :data} (use-query (adset-queries/adset-query {:adset-id adset-id}))

        ns (template-table-ns channel)
        qualify (uix/use-callback (fn [e]
                                    (keyword ns e))
                                  [ns])

        multiselect? (ts/allow-multiple-templates-selection? channel)

        {adset :data} (use-query (adset-queries/adset-query {:adset-id adset-id}))
        {put-template :mutate} (use-mutation (adset-queries/put-template-mutation {:adset-id adset-id :campaign-id campaign-id}))
        on-ok-action (uix/use-callback (fn [templates]
                                         (put-template (adset-queries/append-templates-to-adset adset templates)))
                                       [adset put-template])]
    ($ modal-v2
       {:key (name ns) ; This key ensures that the `add-template-modal` component will be recreated each time `ns` changes.
        :title (if multiselect?
                 "Add Templates"
                 "Select Template")
        :footer ($ footer
                   {:qualify qualify
                    :multiselect-enabled? multiselect?
                    :channel channel
                    :on-ok-action on-ok-action})
        :dialog-content-props {:sx #js {:display "flex"
                                        :overflowY "hidden"}}
        :data-testid :add-template-dialog}
       ($ add-template-modal
          {:qualify qualify
           :multiselect-enabled? multiselect?
           :channel channel}))))
